module.exports = __webpack_public_path__ + "static/media/DP_Timeless_Piazza_DK Grey.c3d9df6a.png";